import { Desktop } from './Desktop';
import { Switcher } from './Switcher';
import { Mobile } from './Mobile';
import ToastProvider from '@/widgets/ToastProvider';

export const Auth = () => {
  return (
    <>
      <ToastProvider />
      <div className="hidden lg:block">
        <Desktop>
          <Switcher />
        </Desktop>
      </div>
      <div className="block lg:hidden">
        <Mobile>
          <Switcher />
        </Mobile>
      </div>
    </>
  );
};
